import React, { useRef, useState } from 'react'
import Logo from '../../components/Logo'
import { useNavigate } from 'react-router-dom'


function EnterDigitCode() {

const navigate =useNavigate()

 
  const [code, setCode] = useState(["", "", "", ""])
  const inputsRef = useRef([])

  const handleChange = (e, index) => {
    const value = e.target.value
    if (!isNaN(value) && value.length <= 1) {
      const newCode = [...code]
      newCode[index] = value
      setCode(newCode)
      
      // Move to the next input
      if (value && index < 3) {
        inputsRef.current[index + 1].focus()
      }
    }
  }
  const handlesumit =()=>{
    navigate('/reset')

  }
  return (
    <div className=''>
      <div className='h-screen w-full bg-white dark:bg-black  grid place-content-center'>
        <div className='h-full w-full p-10 flex space-x-20'>
          <div className=''>
            <div className='mb-20'>
              <Logo />
            </div>
            <div className="">
              <div className="text-[76px] font-sans hidden md:block">
                <h1 className="text-[#2A71E8] text-[70px] font-sans">Let's</h1>
                <h1 className="flex space-x-2 text-[#2A71E8] text-[70px] font-sans">
                  Get<span className="ml-3 text-[#be2117]">Started...</span>
                </h1>
              </div>
            </div>
            <button className="bg-gradient-to-b from-[#BE2117] to-[#09062C] rounded-[20px] p-4 px-11 text-white w-[240px]">
              TRANSLATE
            </button>
          </div>
          <div className='h-full sm:bg-[#f4f4f4] rounded-[50px] dark:bg-[#33333347] w-80 pb-10'>
            <div className='flex justify-center'>
              <div className='border-2 border-[#5D5FEF] w-14 mt-3'></div>
            </div>
            <div className='flex flex-col items-center px-12 mt-28'>
              <div className='space-y-3'>
                <p className='font-[600]'>Enter 4 Digits Code</p>
                <p className='text-[11px] font-[400]'>Enter the 4 digits code that you received on your email.</p>
              </div>
            </div>
            <div className='flex flex-col items-center px-12 mt-20'>
              <div className='space-y-3s'>
                <div className='flex space-x-6'>
                  {code.map((digit, index) => (
                    <div key={index} className='w-10 border border-[#D9D9D9] rounded-[15px] dark:bg-[#33333347]  bg-[#D9D9D9] h-14 mb-10 items-center'>
                      <input
                        type="text"
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        ref={(el) => (inputsRef.current[index] = el)}
                        className='w-10 focus:outline-none border rounded-[15px] dark:bg-[#33333347]  bg-[#D9D9D9] h-14 px-2 p-2 text-center'
                        maxLength={1}
                      />
                    </div>
                  ))}
                </div>
                <button 
                onClick={handlesumit}
                
                className='w-52 border border-[#D9D9D9] rounded-[25px] bg-[#2A71E8] h-10 text-white p-1 text-[15px]'>
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EnterDigitCode
